import { forwardRef } from 'react';
import { IconName } from '@optimus-web/icons';
import { Icon } from '../Icon';
import { Tooltip } from '../Tooltip';

const HelpIcon = forwardRef<HTMLSpanElement, React.PropsWithChildren<{}>>(({ children, ...props }, ref) => (
    <span {...props} ref={ref}>
        <Icon value={IconName.Info} variant="basic" />
    </span>
));
export const HelpTooltip = Tooltip(HelpIcon);
